<script setup>
import { computed } from 'vue'

const props = defineProps({
  dark: { type: Boolean, default: false },
  size: { type: [Number, String], default: 48 }
})

// unique per instance so multiple loaders on one page don't share gradient ids
const uid = `cotap-loader-${Math.random().toString(36).slice(2, 9)}`

const cColor = computed(() => (props.dark ? '#EDE8DB' : '#2c2d31'))
const sizePx = computed(() => (typeof props.size === 'number' ? `${props.size}px` : props.size))
</script>

<template>
  <svg
    :width="sizePx"
    :height="sizePx"
    viewBox="0 0 250 250"
    role="img"
    aria-label="Laden"
  >
    <defs>
      <linearGradient :id="`${uid}-10`" x1="23.71" y1="178.51" x2="267.12" y2="178.51" gradientUnits="userSpaceOnUse">
        <stop offset="0" stop-color="#1f4932" />
        <stop offset=".13" stop-color="#1f4932" />
        <stop offset=".57" stop-color="#8a9588" />
        <animateTransform attributeName="gradientTransform" type="rotate" from="0 125 125" to="360 125 125" dur="2.6s" repeatCount="indefinite" />
      </linearGradient>
      <linearGradient :id="`${uid}-11`" x1="21.41" y1="72.06" x2="228.51" y2="72.06" gradientUnits="userSpaceOnUse">
        <stop offset="0" stop-color="#1f4932" />
        <stop offset=".16" stop-color="#1f4932" />
        <stop offset=".86" stop-color="#2aa744" />
        <animateTransform attributeName="gradientTransform" type="rotate" from="0 125 125" to="360 125 125" dur="2.6s" repeatCount="indefinite" />
      </linearGradient>
      <linearGradient :id="`${uid}-10b`" x1="23.71" y1="185.5" x2="267.12" y2="185.5" gradientUnits="userSpaceOnUse">
        <stop offset="0" stop-color="#1f4932" />
        <stop offset=".13" stop-color="#1f4932" />
        <stop offset=".57" stop-color="#8a9588" />
        <animateTransform attributeName="gradientTransform" type="rotate" from="0 125 125" to="360 125 125" dur="2.6s" repeatCount="indefinite" />
      </linearGradient>
      <linearGradient :id="`${uid}-11b`" x1="21.41" y1="65.07" x2="228.51" y2="65.07" gradientUnits="userSpaceOnUse">
        <stop offset="0" stop-color="#1f4932" />
        <stop offset=".16" stop-color="#1f4932" />
        <stop offset=".86" stop-color="#2aa744" />
        <animateTransform attributeName="gradientTransform" type="rotate" from="0 125 125" to="360 125 125" dur="2.6s" repeatCount="indefinite" />
      </linearGradient>
      <linearGradient :id="`${uid}-68`" x1="224.03" y1="111.48" x2="224.03" y2="138.61" gradientUnits="userSpaceOnUse">
        <stop offset=".17" stop-color="#2aa744" />
        <stop offset=".81" stop-color="#8a9588" />
        <animateTransform attributeName="gradientTransform" type="rotate" from="0 125 125" to="360 125 125" dur="2.6s" repeatCount="indefinite" />
      </linearGradient>
    </defs>

    <path
      :fill="cColor"
      d="M126.92,188.03c-46.9,0-67.29-28.36-67.29-63.4,0-33.18,20.58-62.66,67.48-62.66,40.41,0,60.63,17.03,64.93,46.48.19,1.29-.81,2.46-2.11,2.46h-27.5c-1,0-1.88-.7-2.08-1.68-3.19-15.55-13.53-23.16-32.87-23.16-22.62,0-35.41,13.72-35.41,38.56s11.86,39.3,34.66,39.3c20.44,0,31.52-7.98,34.23-25.28.16-1.03,1.06-1.78,2.1-1.78h27.82c1.29,0,2.28,1.14,2.12,2.43-4.2,32.15-23.75,48.74-66.08,48.74Z"
    />
    <path :fill="`url(#${uid}-10)`" d="M56.39,186.54c-13.91-14.71-21.26-35.8-21.26-60.97H15.99c0,30.15,9.16,55.78,26.5,74.12,19.05,20.15,46.8,30.82,82.52,31.76v-19.15c-30.2-.88-53.27-9.53-68.61-25.76Z" />
    <path :fill="`url(#${uid}-11)`" d="M56.47,64.37c15.5-16.79,38.54-25.75,68.53-26.67v-19.15c-35.59.97-63.36,12-82.59,32.83-17.28,18.72-26.42,44.38-26.42,74.18h19.14c0-17.37,3.7-42.09,21.34-61.19Z" />
    <path :fill="`url(#${uid}-10b)`" d="M193.61,186.54c-15.34,16.22-38.41,24.88-68.61,25.76v19.15c35.72-.94,63.46-11.6,82.52-31.76,14.59-15.43,23.39-36.02,25.81-60.13h-19.26c-2.25,19.02-9.21,35.08-20.46,46.98Z" />
    <path :fill="`url(#${uid}-11b)`" d="M207.59,51.39c-19.23-20.83-47.01-31.86-82.59-32.83v19.15c29.99.92,53.03,9.88,68.53,26.67,13.29,14.4,18.67,31.98,20.51,47.2h19.27c-2.44-23.85-11.2-44.46-25.72-60.19Z" />
    <path :fill="`url(#${uid}-68)`" d="M233.31,111.58h-19.27c.6,4.98.83,9.71.83,13.99,0,4.82-.27,9.49-.81,13.99h19.26c.46-4.54.69-9.21.69-13.99s-.24-9.44-.7-13.99Z" />
  </svg>
</template>
